import React from 'react';
import { AlertModel as ModelFactory } from '@leverege/recovr-models';
import { Flex, Label, Toggle } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import { capitalize } from '@leverege/string-util';
import { getModelFromFactory } from '../../../util/Model';
import S from './Shared.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ToggleEditor(props) {
  const {
    valueKey,
    label,
    value,
    loading
  } = props;
  const Model = getModelFromFactory(ModelFactory);
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "rowM",
    align: "center",
    children: [/*#__PURE__*/_jsx(Toggle, {
      disabled: loading,
      onChange: onModelChange,
      eventData: `set${capitalize(valueKey)}`,
      value: Model[`get${capitalize(valueKey)}`](value)
    }, valueKey), /*#__PURE__*/_jsx(Label, {
      className: S.toggleLabel,
      children: label
    })]
  });
}